/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'

// components
import Breadcrumbs from '../../components/Breadcrumbs'
import BulkUsersUploadStatuses from './components/bulkUsersUploadStatuses'
import SearchBar from './components/searchBar'

// constants
import {
  getBulkStatuses,
  resetBulkStatuses,
} from '../../store/reducers/uploadStatusSlice'

//styles
import styles from './BulkUsersUploadActivity.module.scss'

function BulkUsersUploadActivity() {
  const [searchText, setSearchText] = useState('')
  const [isFetching, setIsFetching] = useState(false)
  const dispatch = useDispatch()

  const getBulkUploadStatuses = async () => {
    setIsFetching(true)
    try {
      if (searchText) {
        await dispatch(getBulkStatuses({ fileName: searchText })).unwrap()
      }
    } catch (error) {
      dispatch(resetBulkStatuses())
      toast.error(`${error?.message ? error.message : 'No Records found'}`)
    } finally {
      setIsFetching(false)
    }
  }

  useEffect(() => {
    if (searchText?.length < 2) {
      dispatch(resetBulkStatuses())
    }
  }, [searchText])

  return (
    <div style={{ height: '90vh' }}>
      <div className={styles.stickyHeader} style={{ backgroundColor: '#F5F5F5',
          width: '100vw',
          padding: '20px', }}>
      <Breadcrumbs className={styles.stickyHeader} value={'Audits / Bulk Search'} />
      <SearchBar
        searchText={searchText}
        setSearchText={setSearchText}
        getBulkUploadStatuses={getBulkUploadStatuses}
      />
      </div>
      {searchText.length >= 1 && (
        <BulkUsersUploadStatuses isFetching={isFetching} />
      )}
    </div>
  )
}

export default BulkUsersUploadActivity
